import { PlanTab } from '../../../../../components/verification/SubscriptionStep';
import { SubscriptionTerm } from '../../../../../services/exports/Constants';

export default {
  sections: {
    term: {
      description: 'Facturat lunar. Anual este un termen de angajament, nu o frecvență de facturare.',
      options: {
        [SubscriptionTerm.Monthly]: 'Termen lunar',
        [SubscriptionTerm.Annual]: 'Termen anual',
      },
    },
    plans: {
      tabs: {
        [PlanTab.actual]: {
          name: 'Model de preț',
          title: 'Scală de prețuri bazată pe succes',
        },
        [PlanTab.legacy]: {
          name: 'Legacy',
          title: 'Planuri',
        },
      },
    },
    add_ons: {
      title: 'Deveniți Pro cu suplimentele noastre pentru Planul Esențial',
      description: 'Atrageți clienți noi și stimulați vizitele repetate cu aceste soluții software.',
    },
  },
  labels: {
    recommended: 'Recomandat',
    basket: 'Coș: <strong>{{amount}}</strong> pe lună',
  },
  buttons: {
    review_and_subscribe: 'Verificați și abonați-vă',
    cancel: 'Anulați',
    basket: 'Înapoi la coș',
    subscribe: 'Abonați-vă',
    update_subscription: 'Actualizați abonamentul',
  },
  toasts: {
    failed_to_load_data: 'Datele nu au putut fi încărcate',
    failed_to_save_contract: 'Contractul de servicii nu a putut fi salvat',
    failed_to_create_subscription: 'Abonamentul nu a putut fi creat',
    subscription_created: 'Abonamentul a fost creat cu succes',
    subscription_updated: 'Abonamentul a fost actualizat cu succes',
  },
};
